function App() {
    return (
        <div className="page-container">
            <div className="page-layout">
                <div className="d-flex flex-column align-items-center">
                    <h1 className='notification text-center'><br/><br/>404. Lost in the Galaxy</h1>
                    <img src="/website/dog_space.webp" alt="dog_space" className="img-responsive" />
                    <h2 className='text-center'>The page you are looking for is not found</h2>
                </div>
            </div>
        </div>
    );
  }
  
  export default App;